<template>
    <main-content>
        <settlement-detail v-if="is_detail_ready"
                           :settlement_data="settlement_data"
                           :settlement_withdraw_type="settlement_withdraw_type"
                           :total_amount="total_amount"
                           :status="status"
        >
        </settlement-detail>
        <button v-if="status === walletTransactionStatus.PENDING"
                class="btn btn-danger mx-2"
                type="button"
                v-text="$t('btn.cancel_settlement')"
                @click="cancel_settlement()"
        >
        </button>
    </main-content>
</template>

<script>
    import MainContent from "@/components/main-content";
    import SettlementDetail from './components/settlement-detail';
    import {walletService} from "@/common/api.service";
    import {walletTransactionStatus} from "@/constants/walletTransactionStatus";

    export default {
        components: {
            MainContent,
            SettlementDetail,
        },
        data() {
            return {
                walletTransactionStatus,
                settlement_data: {},
                settlement_withdraw_type: null,
                total_amount: 0,
                status: null,
                is_detail_ready: false,
            };
        },
        methods: {
            cancel_settlement() {
                walletService.cancelSettlement(this.$route.params.hashid).then(() => {
                    this.$router.push('/wallets');
                });
            },
        },
        mounted() {
            walletService.getSettlementDetailDay(this.$route.params.hashid).then(res => {
                this.settlement_withdraw_type = res.data.data.settlement_withdraw_type;
                this.settlement_data = res.data.data.settlement_data;
                this.total_amount = res.data.data.total_amount;
                this.status = res.data.data.status;
                this.is_detail_ready = true;
            });
        },
    }
</script>